import React from 'react';

export const AGE_REQUIRED_MESSAGE = 'Please confirm you are 18 or older.';

export const AgeConfirm: React.FC<{ checked: boolean; onChange: (checked: boolean) => void }> = ({
  checked,
  onChange,
}) => (
  <label className="flex min-h-[44px] items-center gap-3 cursor-pointer" data-testid="age-confirm">
    <input
      type="checkbox"
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      className="h-5 w-5 rounded border-neutral-300 text-primary-500 focus:ring-primary-500"
    />
    <span className="text-sm font-semibold text-neutral-700">I am 18 or older</span>
  </label>
);
